import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth.store';

/**
 * Frontend gate for /dashboard/restricted/*. Mirrors the JT SystemRoleGuard
 * pattern — non-super-admins get bounced back to /dashboard.
 *
 * This is defence in depth, not the authoritative check. The server's
 * superAdminMiddleware enforces the @jobtetris.com + allowlist gate on every
 * /system/* request, so even if someone swapped this guard out client-side,
 * the API would reject them.
 */
export function SystemRoleGuard({ children }: { children: ReactNode }) {
  const isSuperAdmin = useAuthStore((s) => s.isSuperAdmin);
  const isTakeover = useAuthStore((s) => s.isTakeover);

  if (!isSuperAdmin || isTakeover) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
